import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf49874c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "text-area" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("See more")
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("See more")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.contents, (items, key) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "two-column-row",
      key: key
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: require('@/assets/img/' + items.image),
          alt: ""
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (items.title)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(items.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(items.description), 1),
            _hoisted_7,
            (items.link)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (items.hash)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_router_link, {
                          class: "fas fa-angle-double-right fa-pull-left",
                          to: {
                  name: items.link,
                  hash: items.hash,
                }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_router_link, {
                          class: "fas fa-angle-double-right fa-pull-left",
                          to: { name: items.link }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]))
  }), 128))
}